import { createContext, MouseEvent } from 'react'
import { MCOnboarding } from 'src/interfaces/mcOnboarding'

export interface IMCOnboardingsTableContext {
  refreshOnboardings(): void

  // edit action
  actionAnchor: null | HTMLElement
  onboardingToAction: MCOnboarding | null
  openOnboardingsItemAction(event: MouseEvent<HTMLButtonElement>, onboarding: MCOnboarding): void
  closeOnboardingsItemAction(): void
}

export const MCOnboardingsTableContext = createContext<IMCOnboardingsTableContext>({
  refreshOnboardings: () => {},

  actionAnchor: null,
  onboardingToAction: null,
  openOnboardingsItemAction: () => {},
  closeOnboardingsItemAction: () => {},
})
